import {useQuery} from '@apollo/react-hooks';
import type {ApolloQueryResult} from 'apollo-client';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetInboundEmailRules as GetInboundEmailRulesQuery,
    GetInboundEmailRules_inboundEmailRules as InboundRules,
} from 'nutshell-graphql-types';

import GET_INBOUND_EMAIL_RULES from '../queries/get-inbound-email-rules.graphql';

interface UseGetInboundEmailRulesReturn {
    inboundEmailRules: InboundRules | null;
    error: string | null | undefined;
    isLoading: boolean;
    refetch: () => Promise<ApolloQueryResult<GetInboundEmailRulesQuery>>;
}

export const useGetInboundEmailRules = (): UseGetInboundEmailRulesReturn => {
    const {data, error, loading, refetch} = useQuery<
        GetInboundEmailRulesQuery,
        Record<string, unknown>
    >(GET_INBOUND_EMAIL_RULES, {});

    const inboundEmailRules = data?.inboundEmailRules ?? null;

    return {
        inboundEmailRules,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading: loading,
        refetch,
    };
};
